// extracted by mini-css-extract-plugin
export default {"registerContainer":"register_registerContainer__W7qL5"};